import { render, staticRenderFns } from "./IndicadoresMarketplaceVendasCategoria.vue?vue&type=template&id=18256b85&scoped=true&"
import script from "./IndicadoresMarketplaceVendasCategoria.vue?vue&type=script&lang=js&"
export * from "./IndicadoresMarketplaceVendasCategoria.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresMarketplaceVendasCategoria.vue?vue&type=style&index=0&id=18256b85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18256b85",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
